import zoom from '@gaming/srvg-common-zoom';
import flost from '@gaming/srvg-common-flost';
import debug from '@gaming/srvg-common-debug';
import eventExchange from '@gaming/srvg-common-event-exchange';
import featureInstances from '@gaming/srvg-common-feature-instances';
import { init } from '../../../node_modules/@bremen_webteam/srvg-oddsconversion/lib/oddsconversion.lib'

export default () => {
    const srvg = (window as any).srvg || {};

    // Init the commons
    srvg.debug = Object.assign({}, debug, srvg.debug);
    srvg.featuresInstances = featureInstances;
    zoom.init();
    if(featureInstances.getEnableZoom()) {
        // @ts-ignore: Unreachable code error
        zoom.zoom();
    }
    if(srvg.flostEnabled) {
        srvg.flost = srvg.flost ? Object.assign(srvg.flost, flost) : flost;
    }
    srvg.eventExchange = eventExchange;
    eventExchange.setDebugView(srvg.debugView);
    srvg.oddsconversion = init();
}
